//手机号的校验
export const phone = (msg = '', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger
    },
    {
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号',
    }
    ]
}
//邮箱的校验
export const email = (msg = '', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger
    },
    {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: ['blur', 'change']
    }
    ]
}
//用户名的校验
export const username = (required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入用户名',
        trigger: trigger
    }, {
        min: 2,
        max: 16,
        message: '长度在 2 到 16 个字符'
    }, {
        pattern: /^[0-9a-zA-Z]{2,16}|[\u4E00-\u9FA5]+$/,
        message: '只能输入2-16个字母、数字或中文'
    }]
}
// 姓名的校验
export const realName = (msg = '姓名', required = true, trigger = 'blur') => {
    return [
        {
            required: required,
            message: '请输入' + msg,
            trigger: trigger
        }, {
            min: 2,
            max: 16,
            message: '长度在 2 到 16 个字符'
        }, {
            pattern: /^[\u4E00-\u9FA5]+$/,
            message: msg + '只能为中文'
        }
    ]
}
//密码的校验
export const password = () => {
    return [{
        min: 6,
        max: 16,
        message: '长度在 6 到 16 个字符'
    }, {
        pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/,
        message: '密码为6-16位数字字母组合'
    }]
}
//验证码的校验
export const verificationCode = (required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入验证码',
        trigger: trigger
    }, {
        min: 6,
        max: 6,
        message: '请输入6位验证码'
    }, {
        pattern: /^[0-9]{6}$/,
        message: '只能输入数字'
    }]
}
//验证码的校验
export const num = (required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入期数',
        trigger: trigger
    }, {
        pattern: /^[0-9]*$/,
        message: '只能输入整数'
    }]
}
//最大期刊量
export const naxNums = (msg = '1到99的整数', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入最大期刊数量',
        trigger: trigger
    }, {
        min: 1,
        max: 2,
        message: '请输入' + msg
    }, {
        pattern: /^[1-9][0-9]{0,1}$/,
        message: '请输入1到99的整数'
    }]
}
//邮寄数量
export const naxNumss = (msg = '邮寄数量', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger
    }, {
        pattern: /^[1-9][0-9]{0,1}$/,
        message: '至多输入两位数字'
    }]
}


//邮寄数量
export const price = (msg = '价格', required = true, trigger = 'change') => {
    return [{
        required: required,
        message: '请输入' + msg,
    }, {
        pattern: /^\d*\.{0,1}\d{0,2}$/,
        message: '只能输入整数或小数点2两位',
    },
    ]
}
// 请选择
export const select = (msg = '', required = true, trigger = 'change') => {
    return [
        {
            required: required,
            message: '请选择' + msg,
            trigger: trigger
        }
    ]
}
// 请选择
export const selectcity = (msg = '') => {
    return [
        { required: true, message: '请选择' + msg, trigger: 'change' }
    ]
}
// 请上传
export const upload = (msg = '', required = true) => {
    return [
        {
            required: required,
            message: '请上传' + msg,
        }
    ]
}
// 不能为空
export const empty = (msg = '', required = true, trigger = 'blur') => {
    return [
        {
            required: required,
            message: msg + '不能为空',
        }
    ]
}
export const emptyls = (msg = '', required = true, trigger = 'blur') => {
    return [
        {
            required: required,
            message: "请输入您的姓名",
            trigger: trigger
        },
        {
            // (^\S.*\S$|(^\S{0,1}\S)$)
            pattern: /^(?![0-9])(^\S.*\S$|(^\S{0,1}\S){2,20}$)/,
            message: '首字不可填数字，首尾不可有空格且最小2位字符'
        }

    ]
}

// 不能为空
export const empty1 = (msg = '', required = true, trigger = 'blur') => {
    return [
        {
            required: required,
            message: msg + "",
        }
    ]
}

// // 不能为空
// export const empt= (msg='',required = false, trigger = 'blur') => {
//   return [
//     {
//       required: required,
//       message: msg+'不能为空',
//     }
//   ]
// }

// 不能输入斜杠
export const Slash = (msg = '', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '' + msg,
        trigger: trigger,
    }, {
        // max: 25,
        // message: '最大长度25个汉字'
    }, {
        pattern: /^[^\'\"\=\{\}\[\]\\\/\<\>\n\r]*$/,
        message: '文章标题不允许使用“/”'
    }]
}

// 数字或英文
export const relISSN = (required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入ISSN',
        trigger: trigger
    }, {
        pattern: /^[0-9]{4}-[0-9]{4}$/,
        message: '只能输入2-16个字母'
    }]
}

//数字或小数
export const numberN = (msg = '加急版面', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger,
    }, {
        pattern: /^\d*\.{0,1}\d{0,1}$/,
        message: '只能输入整数或小数'
    }]
}

//身份证
export const identity = (msg = '', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger,
    }, {
        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        message: '身份证号输入不合法'
    }]
}
//身份证
export const identity2 = (msg = '', required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger,
    }, {
        pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        message: '身份证号输入不合法'
    }]
}
//登陆密码的校验
//密码的校验
export const pws = (msg, required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger
    }, {
        min: 6,
        max: 16,
        message: '长度在 6 到 16 个字符'
    }, {
        pattern: /^[a-z0-9]{6,16}$/,
        message: '密码为6-16位数字或字母'
    }]
}
// //密码的校验
export const passwords = (msg, required = true, trigger = 'blur') => {
    return [{
        required: required,
        message: '请输入' + msg,
        trigger: trigger
    }, {
        pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
        message: '密码为8-20位数字字母组合'
    }]
}